import { convertParams } from 'src/utils/utils'
import axios from '../axios'
import { SUPPORTINBOXROUTES } from 'src/router/Api'
import buildInfo from 'src/build-info.json'

const getToken = () => {
	const accessToken = localStorage.getItem('token')
	try {
		return JSON.parse(accessToken)
	} catch {
		return accessToken
	}
}

export const getSupportInboxSourceUser = async () => {
	return await axios.get(SUPPORTINBOXROUTES.sourceUser)
}

export const updateSupportInboxSourceUser = async (source_user_id: string) => {
	return await axios.put(SUPPORTINBOXROUTES.sourceUser, { source_user_id })
}

export const searchSupportInboxSourceUsers = async (params) => {
	return await axios.get(SUPPORTINBOXROUTES.searchSourceUser, {
		params,
	})
}

export const getSupportInboxCampaigns = async (params) => {
	return await axios.get(SUPPORTINBOXROUTES.campaigns, {
		params: convertParams(params),
	})
}

export const createSupportInboxCampaign = async (payload) => {
	return await axios.post(SUPPORTINBOXROUTES.campaigns, payload)
}

export const sendSupportInboxCampaign = async (id: string) => {
	return await axios.post(SUPPORTINBOXROUTES.sendCampaign(id))
}

export const getSupportInboxRecipients = async (id: string, params) => {
	return await axios.get(SUPPORTINBOXROUTES.recipients(id), {
		params: convertParams(params),
	})
}

export const streamSupportInboxCampaign = async (id: string, onMessage) => {
	const response = await fetch(
		`${process.env.REACT_APP_API_URL}/${SUPPORTINBOXROUTES.events(id)}`,
		{
			method: 'GET',
			headers: {
				Authorization: `Bearer ${getToken()}`,
				Accept: 'text/event-stream',
				Platform: 'CMS',
				Version: `${buildInfo.version || ''}`,
			},
		},
	)

	if (!response.ok || !response.body) {
		throw new Error('Support Inbox progress stream failed')
	}

	const reader = response.body.getReader()
	const decoder = new TextDecoder()
	let buffer = ''

	while (true) {
		const { done, value } = await reader.read()
		if (done) break

		buffer += decoder.decode(value, { stream: true })
		const events = buffer.split('\n\n')
		buffer = events.pop() || ''

		events.forEach((eventText) => {
			const eventName = eventText
				.split('\n')
				.find((line) => line.startsWith('event: '))
				?.replace('event: ', '')
			const dataLine = eventText
				.split('\n')
				.find((line) => line.startsWith('data: '))

			if (!dataLine) return
			onMessage({
				event: eventName,
				data: JSON.parse(dataLine.replace('data: ', '')),
			})
		})
	}
}
